import React, { useState } from 'react';
import { ShoppingCart, Package } from '@phosphor-icons/react';
import { MaterialsListTab } from './MaterialsListTab';
import { OrdersTab } from '../site/OrdersTab';

export const ProjectPurchasesTab = ({ project, isAdmin = true }) => {
  const [tab, setTab] = useState('courses');
  const tabStyle = (active) => ({
    padding: '10px 22px', border: 'none', background: 'transparent', cursor: 'pointer',
    fontWeight: active ? 700 : 400,
    borderBottom: active ? '2px solid #002FA7' : '2px solid transparent',
    marginBottom: '-2px', color: active ? '#002FA7' : '#5E5F66',
    display: 'inline-flex', alignItems: 'center', gap: 8,
  });
  return (
    <div data-testid="project-purchases-tab">
      <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid #E2E2E6', marginBottom: 18 }}>
        <button type="button" data-testid="purchases-subtab-courses" onClick={() => setTab('courses')} style={tabStyle(tab === 'courses')}>
          <ShoppingCart size={16} /> Liste de courses
        </button>
        <button type="button" data-testid="purchases-subtab-orders" onClick={() => setTab('orders')} style={tabStyle(tab === 'orders')}>
          <Package size={16} /> Commandes
        </button>
      </div>
      {tab === 'courses' && <MaterialsListTab project={project} isAdmin={isAdmin} />}
      {tab === 'orders' && <OrdersTab projectFilter={project.id} />}
    </div>
  );
};

export default ProjectPurchasesTab;
